import React from 'react';

export const TrialPlanColumnSubtitle = () => (
  <p className="mt-5">
    <span className="fsz-16 center">Try it for free for 14 Days</span>
  </p>
);
